import React from 'react'
import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Button } from '@components/Button'
import { NumberFieldWithLabel } from '@components/Form/Fields'
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '@components/Modal'

export const EditAssumptionsModal = ({
  open,
  onClose,
  inflation,
  onUpdateAssumptions
}) => {
  return(
    <Modal open={open} onClose={onClose}>
      <ModalHeader>General Assumptions</ModalHeader>
      <ModalSubHeader>
        Edit some general assumptions
      </ModalSubHeader>
      <ModalContent>
        <Formik
          onSubmit={ ({ inflation }) => onUpdateAssumptions({
            inflation: parseFloat(inflation) / 100,
          })}
          initialValues={{
            inflation: (inflation * 100).toFixed(2),
          }}
          validationSchema={
            Yup.object().shape({
              inflation: Yup.number('A numerical value for inflation is required')
              .required('A value for inflation is required')
              .max(100, '100 is the maximum value of inflation that can be projected')
              .min(0, '0 is the minimum value of inflation that can be projected'),
            })
          }
        >
          {({ isValid }) =>
            <Form className='app-form'>
              <Box className='mb-8'>
                <NumberFieldWithLabel
                  name={'inflation'}
                  label={'Inflation'}
                />
              </Box>

              <Box
                display='flex'
                justifyContent='center'
                className='flex justify-center gap-4'>
                <Button secondary onClick={onClose}>Go back</Button>
                <Button disabled={!isValid} primary type='submit'>
                  Update assumptions
                </Button>
              </Box>
            </Form>
          }
        </Formik>
      </ModalContent>
    </Modal>
  )
}

EditAssumptionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateScenario: PropTypes.func,
  inflation: PropTypes.number.isRequired,
}
